import { Routes } from '@angular/router';
import { AppPermissions } from '../../auth/models/app-permissions';
import { communityFlagGuard, roleGuard } from '../../auth/guards';
import { titleResolver } from '../../shared/Utils/resolvers/title.resolver';

export const mainPagesRoutes: Routes = [
  {
    path: 'companies/me',
    data: {
      roles: [AppPermissions.COMPANY],
      titleTranslationKey: 'routes.main.company',
    },
    resolve: {
      titleResolver,
    },
    canActivate: [roleGuard],
    loadComponent: async () =>
      await import('./company-main-page/company-main-page.component').then(
        (c) => c.CompanyMainPageComponent
      ),
  },
  {
    path: 'cityhalls/me',
    title: 'City Hall',
    data: {
      roles: [AppPermissions.CITYHALL],
      titleTranslationKey: 'routes.main.cityhall',
    },
    resolve: {
      titleResolver,
    },
    canActivate: [roleGuard],
    loadComponent: async () =>
      await import('./city-hall-main-page/city-hall-main-page.component').then(
        (c) => c.CityHallMainPageComponent
      ),
  },
  {
    path: 'xunta',
    title: 'Xunta',
    data: {
      roles: [AppPermissions.XUNTA],
      titleTranslationKey: 'routes.main.xunta',
    },
    resolve: {
      titleResolver,
    },
    canActivate: [roleGuard],
    loadComponent: async () =>
      await import('./xunta-main-page/xunta-main-page.component').then(
        (c) => c.XuntaMainPageComponent
      ),
  },
  {
    path: 'comunidad',
    data: {
      roles: [
        AppPermissions.COMPANY,
        AppPermissions.CITYHALL,
        AppPermissions.XUNTA,
      ],
      titleTranslationKey: 'routes.main.community',
    },
    resolve: {
      titleResolver,
    },
    canActivate: [roleGuard, communityFlagGuard],
    loadComponent: async () =>
      await import('./community-page/community-page.component').then(
        (c) => c.CommunityPageComponent
      ),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'agenda' },
      {
        path: 'agenda',
        loadComponent: async () =>
          await import(
            '../components/features/community/directory/directory-list/directory-list.component'
          ).then((c) => c.DirectoryListComponent),
      },
      {
        path: 'foro',
        loadComponent: async () =>
          await import(
            '../components/features/community/forum/forum-list/forum-list.component'
          ).then((c) => c.ForumListComponent),
      },
      {
        path: 'foro/:topicId',
        loadComponent: async () =>
          await import(
            '../components/features/community/forum/forum-topic-detail/forum-topic-detail.component'
          ).then((c) => c.ForumTopicDetailComponent),
      },
      {
        path: 'mensajes',
        loadComponent: async () =>
          await import(
            '../components/features/community/messages/messages-layout/messages-layout.component'
          ).then((c) => c.MessagesLayoutComponent),
      },
      {
        path: 'mensajes/:conversationId',
        loadComponent: async () =>
          await import(
            '../components/features/community/messages/messages-layout/messages-layout.component'
          ).then((c) => c.MessagesLayoutComponent),
      },
    ],
  },
];
